import { getPagePath, trans } from '@spotahome/soyuz/client';

import classNames from 'classnames';

import Dropdown from '../Dropdown';

import DropdownItem from '../DropdownItem';

import { DSIcon } from '../../../base';

import SupportCenter from '../SupportCenter';
import DropdownSeparator from '../DropdownSeparator/DropdownSeparator';

import { useUserInfoContext } from '../../context/UserInfoContext';

import PaymentsIcon from '../icons/PaymentsIcon';

import AlertsIcon from '../icons/AlertsIcon';

import Colors from '../utils/colors';

import styles from './LoginIconButton.module.scss';

const getInitialsFromFullname = fullname => {
  if (!fullname) {
    return '';
  }
  const names = fullname.split(' ').map(name => name.charAt(0).toUpperCase());
  return names.slice(0, 2).join('');
};

const getFirstNameFromFullname = fullname => {
  if (!fullname) {
    return '';
  }
  return fullname.split(' ')[0];
};

const LoggedInIconButton = () => {
  const { userInfo } = useUserInfoContext();

  const classes = classNames(
    styles['login-icon-button'],
    styles['login-icon-button--logged']
  );

  return (
    <Dropdown
      title={
        <div className={classes}>
          {getInitialsFromFullname(userInfo.fullname)}
        </div>
      }
      position="right"
      color="light"
      itemsColor="light-redesign"
      dataTest="logged-in-menu"
      disableHover
      roundedBorders
      className="menu-white-redesign"
    >
      <DropdownItem className={styles['login-icon-button__top-block']}>
        <div>
          <div>
            {trans('login.greeting', {
              name: getFirstNameFromFullname(userInfo.fullname)
            })}
          </div>
          <div className={styles['login-icon-button__top-block__email']}>
            {userInfo.email}
          </div>
        </div>
      </DropdownItem>

      <DropdownSeparator />

      <DropdownItem>
        <div>
          <SupportCenter
            backgroundColor="blue"
            photo="whiteShort"
            target="support"
            className={styles['login-icon-button__support-center']}
          />
        </div>
      </DropdownItem>

      <DropdownSeparator />

      <DropdownItem inline>
        <a href={getPagePath('my-profile')}>
          <DSIcon name="perfect_for_couples" />
          {trans('logout.text.my-profile')}
        </a>
      </DropdownItem>

      <DropdownItem inline>
        <a href={getPagePath('marketplace.favorites')}>
          <DSIcon name="fav_line" /> {trans('favorites.title.favorites')}
        </a>
      </DropdownItem>

      <DropdownItem inline>
        <a href={getPagePath('marketplace.alerts')}>
          <AlertsIcon color={Colors.medium} />
          {trans('logout.text.search-preference')}
        </a>
      </DropdownItem>

      <DropdownItem inline>
        <a href={getPagePath('my-bookings')}>
          <DSIcon name="key_locker" />
          {trans('logout.text.user-area')}
        </a>
      </DropdownItem>

      <DropdownItem inline>
        <a href={getPagePath('my-payments')}>
          <PaymentsIcon color={Colors.medium} />
          {trans('header.nav.my-payments.link')}
        </a>
      </DropdownItem>

      <DropdownItem inline>
        <a href={getPagePath('refer-a-friend')}>
          <DSIcon name="diamond" /> {trans('my-referrals.cta.revamp')}
        </a>
      </DropdownItem>

      <DropdownSeparator />

      <DropdownItem>
        <a href={getPagePath('logout')}>{trans('logout.text')}</a>
      </DropdownItem>
    </Dropdown>
  );
};

export default LoggedInIconButton;
